const questions = [
  {
    question: 'Are the classes conducted online?',
    answer:
      'Yes. Our programs are delivered through live online sessions, making it easy for children to learn from home with instructor guidance.',
  },
  {
    question: 'How do I choose the right course for my child?',
    answer:
      'Share your child’s age, current grade and learning goals with our team. We will help you identify the most suitable course and level.',
  },
  {
    question: 'Can we attend a trial class first?',
    answer:
      'Yes. You can contact us on WhatsApp to discuss availability and book a complimentary trial session.',
  },
  {
    question: 'Do you offer programs beyond mathematics?',
    answer:
      'Yes. Alongside Abacus and Vedic Mathematics, we offer Yoga and Meditation, Bhagavad Gita lessons, I-Sense development, Rubik’s Cube, Origami and personal development programs.',
  },
];

function Faq() {
  return (
    <section className="faq" id="faq">
      <div className="container faq-layout">
        <div className="faq-intro">
          <span className="eyebrow">Helpful answers</span>
          <h2>Questions families often ask.</h2>
          <p>
            Need something more specific? Our team will be happy to guide you.
          </p>
          <a href="#contact" className="text-link">Ask us a question <span>→</span></a>
        </div>

        <div className="faq-list">
          {questions.map((item, index) => (
            <details className="faq-item" key={item.question} open={index === 0}>
              <summary>
                <span>{item.question}</span>
                <span className="faq-toggle" aria-hidden="true">+</span>
              </summary>
              <p>{item.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Faq;
